<script setup lang="ts">
import type { CatalogData } from '../types/catalog-pdf.types';
import CoverPage from './CoverPage.vue';
import LegendPage from './LegendPage.vue';
import ProductPage from './ProductPage.vue';
import VerticalSummaryPage from './VerticalSummaryPage.vue';

const props = defineProps<{ data: CatalogData }>();
</script>

<template>
  <div class="catalog-pdf">
    <CoverPage :title="props.data.catalogName" />

    <LegendPage />

    <template v-for="category in props.data.categories" :key="category.categoryName">
      <!-- Vertical summary: one thumbnail per product (first colorway of first gender) -->
      <VerticalSummaryPage
        :title="category.categoryName"
        :products="
          category.products.map((p) => ({
            productName: p.productName,
            imageUrl: p.genders[0]?.colorways[0]?.imageUrl ?? '',
          }))
        " />

      <!-- Product pages with gender pagination -->
      <ProductPage
        v-for="product in category.products"
        :key="product.productName"
        :product-name="product.productName"
        :pricing="product.pricing"
        :genders="product.genders" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.catalog-pdf {
  background-color: var(--pdf-background-light-color);
  font-family: sans-serif;

  @media print {
    background-color: transparent;
  }
}
</style>
